import { useMapEvents } from "react-leaflet";
import { useSelector } from "react-redux";
import { toast } from 'react-toastify';
import {DADATA_TOKEN, GET_MAP_CENTER} from "../const";
import {useTaxiActions, useUIActions} from "../store/useActions";
import {useEffect} from "react";
import axios from "axios";
import {useUISelector} from "../store/useSelectors";
import {nominatimReverse} from "../api/nominatim";
import {nominatimProcessResult} from "../services/nominatim";
import Cookies from 'js-cookie';

export const LocationPicker = (props) => {
  const { pickLocationField } = useUISelector();
  const { setCenterPosition } = useUIActions();
  const { setStartAddress, setEndAddress, setStartLocation, setEndLocation } =
    useTaxiActions();
  const { startAddress, endAddress } = useSelector((state) => state.taxi);

  // Detect MAX platform
  const isMaxPlatform = !new URLSearchParams(window.location.search).get("telegram_auth_token");

  useEffect(() => {
      axios.get(GET_MAP_CENTER)
            .then(response => {
                var payload = response.data
                if (!payload) return;
                var coords = payload.web_app_map_center.coordinates
                if (coords && coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
                    setCenterPosition([...coords].reverse())
                }
                if (!Cookies.get('start-address-city')) {
                    const [lon, lat] = payload.web_app_map_center.coordinates;
                    nominatimReverse(lat, lon)
                        .then(r => r.data)
                        .then(resultJson => {
                            if (!resultJson) return;
                            const result = nominatimProcessResult(resultJson);
                            Cookies.set('start-address-state', result.address?.state ?? '', { expires: 2 });
                            Cookies.set('start-address-city', (result.address?.city || result.address?.town) ?? '', { expires: 2 });
                        })
                        .catch(() => {});
                }
            })
            .catch(error => {
                console.error(error)
            })
  }, [])

  const mapEvents = useMapEvents({
    click(event) {
      // Determine which field to fill
      let targetField = pickLocationField;

      // MAX: auto-detect field if none selected
      // Read current values from Redux store directly to avoid stale closure
      if (!targetField && isMaxPlatform) {
        const store = window.__REDUX_STORE__;
        const currentTaxi = store ? store.getState().taxi : {};
        const curStart = currentTaxi.startAddress || startAddress;
        const curEnd = currentTaxi.endAddress || endAddress;
        if (!curStart) {
          targetField = "start";
        } else if (!curEnd) {
          targetField = "end";
        }
        if (targetField) {
          console.log("[MAP-CLICK] MAX auto-select field:", targetField);
        }
      }

      if (!targetField) return;

      const coords = event.latlng;
      try {
        nominatimReverse(coords.lat, coords.lng)
          .then((response) => response.data)
          .then((resultJson) => {
            if (!resultJson) return;
            const result = nominatimProcessResult(resultJson);
            if (targetField === "start") {
              setStartAddress(result.set_name);
              Cookies.set('start-address-state', result.address?.state ?? '', { expires: 2 })
              Cookies.set('start-address-city', result.address?.city || result.address?.town || '', { expires: 2 })
              setStartLocation({
                latitude: parseFloat(coords.lat),
                longitude: parseFloat(coords.lng),
              });
            } else {
              setEndAddress(result.set_name);
              setEndLocation({
                latitude: parseFloat(coords.lat),
                longitude: parseFloat(coords.lng),
              });
            }
          }).catch(error => toast.error("\u041d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u043f\u0440\u0435\u0434\u0435\u043b\u0438\u0442\u044c \u0430\u0434\u0440\u0435\u0441"));
        } catch (error) {
            toast.error("\u041d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u043f\u0440\u0435\u0434\u0435\u043b\u0438\u0442\u044c \u0430\u0434\u0440\u0435\u0441");
        }
    },
  });

  return null;
};
